import React, { useEffect, useState } from 'react';
import { Collapse, Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Icon } from '../../index';
import clsx from 'clsx';
import IconButton from '@material-ui/core/IconButton';
import { Layers as LayersIcon } from '@material-ui/icons';
import { drawerStyles, useStyles } from './drawerStyle';
import { includeRoles } from '../../../router/helper';
import Raise from '../../animation/raise';

const NavigationDrawer = ({ title, data, selectedItem, drawerColor = '#FFF', selectedColor = 'red', roles }) => {
  const [selectedId, setSelectedId] = useState(selectedItem);
  const classes = drawerStyles();
  const styles = useStyles();
  const [open, setOpen] = useState(JSON.parse(localStorage.getItem('drowerOpen')));
  const [openElement, setOpenElement] = useState(() => {
    const currentPath = window.location.pathname;

    const parent = data.find((item) => item.type === 'list' && item.items.some((subItem) => subItem.path === currentPath));

    return parent?.id || false;
  });

  const isBigScreen = useMediaQuery('(max-width:1265px)');

  useEffect(() => {
    return () => {
      if (isBigScreen) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    };
  }, [isBigScreen]);

  const handleDrawerOpen = () => {
    setOpen(true);
    saveDrawerModification(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
    saveDrawerModification(false);
  };

  const saveDrawerModification = (drowerOpen) => {
    localStorage.setItem('drowerOpen', JSON.stringify(drowerOpen));
  };
  const handleOpenELementClick = (element) => {
    if (element === openElement) {
      setOpenElement(false);
      return;
    }
    setOpenElement(element);
  };

  const factory = (element) => {
    switch (element.type) {
      case 'item':
        return renderItem(element);
      case 'list':
        return renderItemList(element);
    }
  };

  const renderListItems = (elements) => {
    return elements.map((element) => factory(element));
  };

  const renderItem = (element) => {
    const ElementIcon = element.icon(element.id === selectedId ? selectedColor : 'black');
    return (
      <ListItem
        button
        selected={element.id === selectedId}
        onClick={() => {
          setSelectedId(element.id);
        }}
        classes={{ root: styles.root, selected: styles.selected }}
        component={Link}
        to={element.path}
        key={element.id}
        disabled={!includeRoles(element.roles, roles)}
      >
        <ListItemIcon>{ElementIcon}</ListItemIcon>
        <ListItemText primary={element.name} style={{ color: element.id === selectedId ? selectedColor : 'black' }} />
      </ListItem>
    );
  };

  const renderItemList = (element) => {
    const ElementIcon = element.icon(element.id === selectedId ? selectedColor : 'black');
    return (
      <div key={element.id}>
        <ListItem button onClick={() => handleOpenELementClick(element.id)} classes={{ selected: classes.selected }}>
          <ListItemIcon>{ElementIcon}</ListItemIcon>
          <ListItemText style={{ color: 'black' }} primary={element.name} />
          {openElement === element.id ? (
            <Icon name={'chevron-up'} type={'solid'} size={15} color={'black'} />
          ) : (
            <Icon name={'chevron-down'} type={'solid'} size={15} color={'black'} />
          )}
        </ListItem>
        <Collapse in={openElement === element.id} timeout="auto" unmountOnExit>
          <List component="div" disablePadding className={classes.nested}>
            {renderListItems(element.items)}
          </List>
        </Collapse>
      </div>
    );
  };

  return (
    <Drawer
      variant="permanent"
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      <div style={{ background: drawerColor }}>
        {title && (
          <>
            <List component="nav" aria-label="main mailbox folders">
              {open && (
                <ListItem className={classes.logo} selected={false}>
                  <IconButton className={classes.toolbarIcon} onClick={handleDrawerClose}>
                    <Raise height={10} timing={200}>
                      <LayersIcon style={{ color: selectedColor, fontSize: 40 }} />
                    </Raise>
                  </IconButton>
                  <ListItemText
                    disableTypography
                    primary={
                      <Typography type="body2" className={classes.text}>
                        {title}
                      </Typography>
                    }
                  />
                </ListItem>
              )}
              {!open && (
                <ListItem className={classes.logoClose} selected={false}>
                  <IconButton onClick={handleDrawerOpen}>
                    <Raise height={10} timing={200}>
                      <LayersIcon style={{ color: selectedColor, fontSize: 45 }} />
                    </Raise>
                  </IconButton>
                </ListItem>
              )}
            </List>
          </>
        )}
        <List component="nav" disablePadding>
          {renderListItems(data)}
        </List>
      </div>
    </Drawer>
  );
};

export default NavigationDrawer;
